// Initiate Web Behaviour Tracking (this MUST come prior any other dmPt calls)
// Do not change this.
// Ref: https://support.dotdigital.com/en/articles/9116182-integrate-dotdigital-with-drupal
(function(w, d, u, t, o, c) {
  w['dmtrackingobjectname'] = o;
  c = d.createElement(t);
  c.async = 1;
  c.src = u;
  t = d.getElementsByTagName(t)[0];
  t.parentNode.insertBefore(c, t);
  w[o] = w[o] || function() {
    (w[o].q = w[o].q || []).push(arguments);
  };
})(window, document, '//static.trackedweb.net/js/_dmptv4.js', 'script', 'dmPt');

(function (Drupal, drupalSettings, cookies) {
  Drupal.behaviors.dot_digital_tracking = {
    attach: function (context) {
      const hashedEmail = cookies.get('hashed_email');
      const customerId = cookies.get('customer_id');
      const customerLoggedIn = typeof hashedEmail !== 'undefined' && typeof customerId !== 'undefined';
      const envProgramId = drupalSettings.env.name !== 'prod' ? 'DM-9093002146-01' : 'DM-1938921552-01';

      if (customerLoggedIn) {
        // Trigger the tracking.
        window.dmPt('create', envProgramId, window.location.host);
        window.dmPt('track');
      }
    },
  };
})(Drupal, drupalSettings, window.Cookies);
